import { render } from "./FileImageComponent.vue?vue&type=template&id=5572c70a"
import script from "./FileImageComponent.vue?vue&type=script&lang=js"
export * from "./FileImageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__